"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _helpers = require("../../../dist/utils/helpers");
var _ErrorHandlerModule = _interopRequireDefault(require("../../scss/utils/ErrorHandler.module.scss"));
function ErrorHandler({
  title,
  message
}) {
  return /*#__PURE__*/_react.default.createElement("error-handler", null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_ErrorHandlerModule.default['error-handler__message'], 'error-handler__message'])
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: (0, _helpers.classes)([_ErrorHandlerModule.default['error-handler__title'], 'error-handler__title'])
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _helpers.classes)([_ErrorHandlerModule.default['error-handler__message-text'], 'error-handler__message-text'])
  }, (0, _htmlReactParser.default)(message))));
}
var _default = exports.default = ErrorHandler;